const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 934.759 124.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(21, 28, 98)"
    },
    d: "M 412.207 105.653 C 399.869 105.653 392.091 105.653 392.091 105.653 L 392.094 105.655 C 194.877 105.758 3.653 108.621 3.653 112.138 C 3.653 115.71 200.806 118.607 401.202 118.623 L 412.979 118.623 C 412.979 118.623 448.646 119.623 448.646 112.138 C 448.646 104.653 424.546 105.653 412.207 105.653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#3a3a3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 130.948 69.3 C 145.351 41.872 145.261 13.462 130.751 5.844 C 116.241 -1.776 92.803 14.281 78.401 41.706 C 63.999 69.134 64.088 97.545 78.599 105.164 C 93.109 112.783 116.547 96.726 130.948 69.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 125.364 66.367 C 137.328 43.584 137.763 20.25 126.336 14.25 C 114.911 8.25 95.948 21.856 83.985 44.64 C 72.023 67.422 71.587 90.757 83.015 96.757 C 94.44 102.755 113.403 89.15 125.364 66.367"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 183.596 96.943 C 180.561 102.727 177.552 108.848 166.899 113.819 C 156.245 118.789 145.796 102.507 131.847 110.358 C 111.545 121.786 92.261 112.338 92.261 112.338 L 78.599 105.164 C 93.109 112.783 116.547 96.726 130.948 69.3 C 145.351 41.872 145.261 13.462 130.751 5.844 L 144.413 13.017 C 144.413 13.017 163.139 23.528 165.259 46.727 C 166.715 62.669 186.051 62.026 188.009 73.618 C 189.967 85.209 186.633 91.161 183.596 96.943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#6c5f1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 92.328 72.435 L 47.204 48.741 C 42.844 46.453 40.142 43.009 41.171 41.049 C 42.199 39.09 46.568 39.36 50.928 41.649 L 100.993 67.938 L 92.328 72.435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#b39b1c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 101.717 66.564 L 51.651 40.274 C 47.291 37.984 42.92 37.716 41.894 39.676 L 41.171 41.049 C 42.199 39.09 46.568 39.36 50.928 41.649 L 100.993 67.938 L 101.717 66.564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#b39b1c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 47.927 45.193 C 46.918 44.664 46.234 43.873 46.11 43.194 C 45.895 43.292 45.727 43.434 45.626 43.625 C 45.234 44.374 46.01 45.557 47.363 46.267 C 48.715 46.977 50.131 46.946 50.524 46.197 C 50.624 46.006 50.644 45.786 50.603 45.554 C 49.975 45.838 48.934 45.721 47.927 45.193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#17b4de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 47.927 45.193 C 48.934 45.721 49.975 45.838 50.603 45.554 C 50.48 44.874 49.794 44.085 48.786 43.556 C 47.778 43.028 46.739 42.91 46.11 43.194 C 46.234 43.873 46.918 44.664 47.927 45.193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#6c5f1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 110.724 37.404 L 65.599 13.709 C 61.239 11.42 58.538 7.976 59.567 6.017 C 60.594 4.058 64.963 4.326 69.324 6.617 L 119.389 32.906 L 110.724 37.404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#b39b1c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 120.111 31.53 L 70.045 5.241 C 65.686 2.952 61.316 2.684 60.288 4.642 L 59.567 6.017 C 60.594 4.058 64.963 4.326 69.324 6.617 L 119.389 32.906 L 120.111 31.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#b39b1c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 66.321 10.16 C 65.315 9.632 64.627 8.841 64.506 8.162 C 64.291 8.26 64.122 8.402 64.022 8.593 C 63.628 9.342 64.406 10.525 65.756 11.234 C 67.111 11.945 68.525 11.914 68.919 11.165 C 69.02 10.974 69.039 10.754 68.999 10.521 C 68.368 10.805 67.329 10.689 66.321 10.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#17b4de",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 66.321 10.16 C 67.329 10.689 68.368 10.805 68.999 10.521 C 68.873 9.844 68.189 9.052 67.181 8.524 C 66.173 7.994 65.135 7.878 64.506 8.162 C 64.627 8.841 65.315 9.632 66.321 10.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#21201f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 442.758 83.321 C 442.535 82.098 440.87 84.542 439.703 83.598 C 438.537 82.653 440.314 82.819 438.537 81.653 C 436.759 80.486 436.037 82.986 435.537 82.319 C 435.085 81.717 435.975 81.61 435.003 81.143 C 432.021 106.213 403.786 107.058 403.786 107.058 L 402.957 107.058 C 402.957 107.058 397.614 107.058 384.898 107.058 C 367.437 107.058 336.071 107.058 285.534 107.058 C 225.55 107.058 196.465 100.215 184.131 95.929 C 183.952 96.269 183.773 96.607 183.596 96.943 C 182.752 98.553 181.904 100.188 180.899 101.817 C 193.688 106.482 223.436 113.648 285.534 113.648 L 402.957 113.648 L 402.957 113.505 C 439.434 111.46 441.133 86.089 442.091 85.876 C 443.091 85.654 442.981 84.542 442.758 83.321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#3a3a3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 434.647 80.986 C 433.091 80.376 433.481 81.931 431.814 81.486 C 430.147 81.042 431.925 80.265 430.591 79.486 C 429.258 78.709 430.537 80.931 428.925 81.431 C 427.313 81.931 428.537 80.376 426.425 79.209 C 424.313 78.042 424.537 79.153 424.314 81.265 C 424.091 83.376 424.703 82.819 426.091 83.265 C 427.479 83.709 426.535 85.542 426.535 85.542 C 420.535 100.321 402.425 100.466 402.425 100.466 L 285.534 100.466 C 227.122 100.466 198.682 93.838 186.911 89.881 C 186.116 92.074 185.125 94.03 184.131 95.929 C 196.465 100.215 225.55 107.058 285.534 107.058 C 336.071 107.058 367.437 107.058 384.898 107.058 C 397.614 107.058 402.957 107.058 402.957 107.058 L 403.786 107.058 C 403.786 107.058 432.021 106.213 435.003 81.143 C 434.901 81.094 434.797 81.045 434.647 80.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#606263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 431.481 81.361 C 427.743 101.357 407.03 103.238 402.957 103.412 L 402.957 103.35 L 285.534 103.35 C 228.033 103.35 198.849 96.978 185.736 92.701 C 185.621 92.95 185.504 93.198 185.385 93.443 C 198.584 97.76 227.892 104.174 285.534 104.174 L 402.957 104.174 L 402.957 104.079 C 407.101 103.905 428.297 102.001 432.131 81.521 C 431.866 81.485 431.625 81.412 431.481 81.361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#606263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 439.265 82.598 C 439.277 82.267 439.141 82.079 439.014 81.97 C 433.475 107.482 406.809 109.835 402.957 110.038 L 402.957 109.942 L 285.534 109.942 C 223.413 109.942 194.343 102.505 182.88 98.305 C 182.751 98.547 182.621 98.789 182.491 99.033 C 194.028 103.274 223.232 110.765 285.534 110.765 L 402.957 110.765 L 402.957 110.705 C 406.77 110.507 433.201 108.218 439.395 83.3 C 439.303 83.142 439.253 82.927 439.265 82.598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#02a04e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 432.185 81.542 C 433.411 81.662 433.226 80.427 434.647 80.986 C 434.789 81.042 434.887 81.089 434.983 81.135 C 435.501 78.206 435.939 73.013 434.013 67.879 L 431.515 68.817 C 433.423 73.9 432.674 79.221 432.185 81.542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#e01d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 428.671 81.497 C 428.747 81.482 428.83 81.461 428.925 81.431 C 430.537 80.931 429.258 78.709 430.591 79.486 C 431.778 80.178 430.509 80.87 431.385 81.328 C 431.794 78.059 431.567 72.226 426.273 67.366 L 424.469 69.33 C 429.202 73.676 429.085 78.952 428.671 81.497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#bedf14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 438.537 81.653 C 438.543 81.658 438.549 81.662 438.555 81.666 C 439.209 79.057 440.713 74.743 443.99 71.357 L 442.074 69.503 C 437.69 74.031 436.142 79.871 435.651 82.414 C 436.149 82.637 436.89 80.571 438.537 81.653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#bb269a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 449.377 72.115 C 442.969 74.331 440.361 79.127 439.306 82.318 C 439.607 82.806 438.83 82.89 439.703 83.598 C 440.37 84.138 441.198 83.573 441.827 83.215 C 442.702 80.578 444.883 76.491 450.249 74.637 L 449.377 72.115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(21, 28, 98)"
    },
    d: "M 937.536 107.758 C 792.811 106.509 622.054 105.709 538.577 105.655 L 538.579 105.653 C 538.579 105.653 532.248 105.653 522.202 105.653 C 512.157 105.653 492.536 104.653 492.536 112.138 C 492.536 119.623 521.574 118.623 521.574 118.623 L 531.162 118.623 C 616.477 118.615 790.71 117.818 937.536 116.55 L 937.536 107.758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#21201f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1039.131 113.648 L 1039.131 107.058 C 940.797 107.058 572.346 107.058 556.286 107.058 C 543.57 107.058 538.227 107.058 538.227 107.058 L 537.398 107.058 C 537.398 107.058 509.163 106.213 506.18 81.143 C 505.207 81.61 506.098 81.717 505.646 82.319 C 505.146 82.986 504.423 80.486 502.646 81.653 C 500.868 82.819 502.646 82.653 501.479 83.598 C 500.312 84.542 498.647 82.098 498.424 83.321 C 498.202 84.542 498.091 85.654 499.091 85.876 C 500.051 86.089 501.748 111.46 538.227 113.505 L 538.227 113.648 L 1039.131 113.648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#3a3a3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1039.131 100.466 L 538.758 100.466 C 538.758 100.466 520.647 100.321 514.647 85.542 C 514.647 85.542 513.703 83.709 515.091 83.265 C 516.479 82.819 517.091 83.376 516.868 81.265 C 516.646 79.153 516.87 78.042 514.758 79.209 C 512.646 80.376 513.87 81.931 512.258 81.431 C 510.646 80.931 511.924 78.709 510.591 79.486 C 509.258 80.265 511.035 81.042 509.368 81.486 C 507.702 81.931 508.091 80.376 506.535 80.986 C 506.387 81.045 506.283 81.094 506.18 81.143 C 509.163 106.213 537.398 107.058 537.398 107.058 L 538.227 107.058 C 538.227 107.058 543.57 107.058 556.286 107.058 C 572.346 107.058 940.797 107.058 1039.131 107.058 L 1039.131 100.466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#606263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1039.131 104.174 L 1039.131 103.35 L 538.227 103.35 L 538.227 103.412 C 534.152 103.238 513.44 101.357 509.702 81.361 C 509.559 81.412 509.316 81.485 509.052 81.521 C 512.887 102.001 534.082 103.905 538.227 104.079 L 538.227 104.174 L 1039.131 104.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#606263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1039.143 110.765 L 1039.143 109.942 L 538.239 109.942 L 538.239 110.038 C 534.386 109.835 507.719 107.482 502.182 81.97 C 502.054 82.079 501.919 82.267 501.93 82.598 C 501.942 82.927 501.891 83.142 501.8 83.3 C 507.994 108.218 534.424 110.507 538.239 110.705 L 538.239 110.765 L 1039.143 110.765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#02a04e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 508.999 81.542 C 507.772 81.662 507.958 80.427 506.535 80.986 C 506.395 81.042 506.296 81.089 506.199 81.135 C 505.683 78.206 505.244 73.013 507.171 67.879 L 509.668 68.817 C 507.759 73.9 508.51 79.221 508.999 81.542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#e01d25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 512.512 81.497 C 512.435 81.482 512.354 81.461 512.258 81.431 C 510.646 80.931 511.924 78.709 510.591 79.486 C 509.406 80.178 510.675 80.87 509.799 81.328 C 509.39 78.059 509.616 72.226 514.911 67.366 L 516.715 69.33 C 511.98 73.676 512.098 78.952 512.512 81.497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#bedf14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 502.646 81.653 C 502.639 81.658 502.635 81.662 502.628 81.666 C 501.974 79.057 500.47 74.743 497.192 71.357 L 499.11 69.503 C 503.494 74.031 505.04 79.871 505.531 82.414 C 505.034 82.637 504.294 80.571 502.646 81.653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#bb269a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 491.806 72.115 C 498.215 74.331 500.822 79.127 501.876 82.318 C 501.576 82.806 502.354 82.89 501.479 83.598 C 500.812 84.138 499.984 83.573 499.356 83.215 C 498.48 80.578 496.3 76.491 490.934 74.637 L 491.806 72.115"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.a37b9112927beea4f737a011ce530e0f.svg";
export { ForwardRef as ReactComponent };